import { render, staticRenderFns } from "./not_vip_toast.vue?vue&type=template&id=befaf436&scoped=true&"
import script from "./not_vip_toast.vue?vue&type=script&lang=js&"
export * from "./not_vip_toast.vue?vue&type=script&lang=js&"
import style0 from "./not_vip_toast.vue?vue&type=style&index=0&id=befaf436&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befaf436",
  null
  
)

export default component.exports